export async function getIp() {
  const ipResponse = await fetch("https://api.ipify.org?format=json");
  const ipData = await ipResponse.json();
  const userIp = ipData.ip;
  return userIp;
}

export const formatProjectDate = (date: string | Date) => {
  if (date instanceof Date) {
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
  }
  const [month, year] = date.split('-');
  return new Date(parseInt(year), parseInt(month) - 1).toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long' 
  });
};

// export const chatbot_user_email = sessionStorage?.getItem("chatbot_user_email");
// export const last_chatbot_user_email = sessionStorage?.getItem(
//   "last_chatbot_user_email"
// );

// export const getUserEmail = (): string | null => {
//   if (typeof window !== "undefined") {
//     return sessionStorage.getItem("chatbot_user_email");
//   }
//   return null;
// };

export const myPhotoPath = "/assets/hamza.jpg";

export const chatbot_user_email =
  typeof window !== "undefined"
    ? sessionStorage?.getItem("chatbot_user_email")
    : null;

export const last_chatbot_user_email =
  typeof window !== "undefined"
    ? sessionStorage?.getItem("last_chatbot_user_email")
    : null;

export const chat_email_verified =
  typeof window !== "undefined"
    ? sessionStorage?.getItem("email_verified")
    : null;

export const code_sent_not_verified =
  typeof window !== "undefined"
    ? sessionStorage?.getItem("code_sent_not_verified")
    : null;

// Email validation
export const isValidEmail = (email: unknown): boolean => {
  if (typeof email !== "string") return false;
  const trimmed = email.trim();
  if (trimmed === "") return false;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmed)) return false;

  if (trimmed.length > 254) return false;
  const localPart = trimmed.split("@")[0];
  if (localPart.length > 64) return false;

  return true;
};

export function generateAIResponse(message: string): string {
  const lowerMessage = message.toLowerCase();

  // Portfolio-specific responses
  if (lowerMessage.includes("project") || lowerMessage.includes("work")) {
    return "I've worked on various full-stack applications using React, Next.js, and Node.js. I'm particularly passionate about integrating AI and automation tools like N8N. Would you like to know about a specific project?";
  }

  if (
    lowerMessage.includes("ai") ||
    lowerMessage.includes("machine learning")
  ) {
    return "I'm fascinated by AI and machine learning! I've been exploring LLMs, computer vision, and building AI-powered applications. I also work with automation workflows using N8N. What aspect interests you most?";
  }

  if (
    lowerMessage.includes("cloud") ||
    lowerMessage.includes("aws") ||
    lowerMessage.includes("azure")
  ) {
    return "I have experience with cloud platforms including AWS and Azure. I've deployed applications using serverless functions, containerization with Docker, and CI/CD pipelines. Are you looking to learn about a specific cloud service?";
  }

  if (lowerMessage.includes("automation") || lowerMessage.includes("n8n")) {
    return "N8N is one of my favorite tools! I use it to create powerful automation workflows that connect different services and APIs. I've built workflows for data processing, notifications, and integrating various business tools. What kind of automation are you interested in?";
  }

  if (
    lowerMessage.includes("contact") ||
    lowerMessage.includes("hire") ||
    lowerMessage.includes("work together")
  ) {
    return "I'd love to discuss potential collaboration! You can reach me through the contact form on this portfolio, or connect with me on LinkedIn. What kind of project are you working on?";
  }

  if (
    lowerMessage.includes("hello") ||
    lowerMessage.includes("hi") ||
    lowerMessage.includes("hey")
  ) {
    return "Hello! I'm excited to chat with you about my work in full-stack development, AI, cloud technologies, and automation. What would you like to explore?";
  }

  // Default response
  return "That's an interesting question! I'm passionate about full-stack development, AI/ML, cloud technologies, and automation. Could you tell me more about what specifically interests you, or would you like to know about my recent projects?";
}
